import { render, staticRenderFns } from "./WebHooks.vue?vue&type=template&id=4e9d5472&"
import script from "./WebHooks.vue?vue&type=script&lang=js&"
export * from "./WebHooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports